import React from "react";
import "./AboutTagline.css";
function AboutTagline() {
  return (
    <div className="AboutTagline">
      <h1>A Tapestry of Culture, Gastronomy, and Natural Splendor</h1>
      <div className="AboutTagline__p">
        <p>
          Nestled along the shimmering Mediterranean coastline, Costa Blanca
          epitomizes the essence of Spanish charm, offering a rich tapestry of
          cultural experiences, exquisite gastronomy, and breathtaking
          landscapes seamlessly blending sea and mountain vistas.
        </p>
      </div>
    </div>
  );
}

export default AboutTagline;
